//
// locales/glitch/hr.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/hr';
import localeData from 'react-intl/locale-data/hr.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
